import React, { useState } from "react";
import { LoadingButton } from "./LoadingButton";
import { useAppDispatch, useAppSelector } from "../../redux/hooks/hooks";
import { selectSubmitCounter, setSubmitCount } from "../../redux/slices/submitCounterSlice";
import { useTranslation } from "react-i18next";

interface IProps {
  onSave: () => void;
  onPost: () => void;
  onClose: () => void;
  onCancel: () => void;
  onSendToRs?: () => void;
  handleApplyChanges?: any;
  onActivate?: () => void;
  handleUploadFile: (file: File) => void;
  exportToExcel: () => void;
  fileName: any;
  showOnPost?:boolean;
  setFileName: any;
  children?: React.ReactNode;
}

export const DocumentModalViewHeader = ({
  onSave,
  handleApplyChanges,
  onPost,
  onClose,
  showOnPost,
  onCancel,
  handleUploadFile,
  exportToExcel,
  fileName,
  setFileName,
  onSendToRs,
  onActivate,
  children
}: IProps) => {
  const { t } = useTranslation();
  const [showPopup, setShowPopup] = useState(false);
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [file, setFile] = useState<File | null>(null);
  const [isExportOpen, setIsExportOpen] = useState(false);
  const [postClicked, setPostClicked] = useState<boolean>(false);
  const [saveClicked, setSaveClicked] = useState<boolean>(false);
  const [cancelClicked, setCancelClicked] = useState<boolean>(false);
  const [sentToRsClicked, setSendToRsClicked] = useState<boolean>(false);
  const [activateClicked, setActivateClicked] = useState<boolean>(false);
  const counter = useAppSelector(selectSubmitCounter);
  const isButtonShown = useAppSelector((state: any) => state.wayBillButton.isButtonShown);

  // const [clicked, setClicked] = useState(false);

  const dispatch = useAppDispatch();

  const handleInputChange = (event: any) => {
    setFileName(event.target.value);
  };
  const handlePopupToggle = () => {
    setShowPopup((prevState) => !prevState);
  };

  const handlePostClick = async () => {
    setPostClicked(true);
    // await new Promise((resolve) => setTimeout(resolve, 500));
    await onPost();
    dispatch(setSubmitCount(counter + 1));
    setPostClicked(false);
  };

  const handleSaveClick = async () => {
    setSaveClicked(true);
    await onSave();
    dispatch(setSubmitCount(counter + 1));
    setSaveClicked(false);
  };

  const handleCancelClick = async () => {
    setCancelClicked(true);
    await onCancel();
    setCancelClicked(false);
  };

  const handleSendToRsClick = async () => {
    setSendToRsClicked(true);
    onSendToRs && (await onSendToRs());
    setSendToRsClicked(false);
  };

  const handleActivateClick = async () => {
    setActivateClicked(true);
    onActivate && (await onActivate());
    setActivateClicked(false);
  };

  return (
    <>
      <div className={"d-flex w-100 mb-3 justify-content-between mt-2"}>
        <>
          {!showOnPost && <button type={"button"} className="btn btn-success me-2 d-flex align-items-center" onClick={handlePostClick}>
            {postClicked ? (
              <>
                <i className="fa-solid fa-spinner fa-spin-pulse me-2"></i>
                {t("Posting")}
              </>
            ) : (
              <>
                <i className="fa-solid fa-circle-check me-2"></i>
                {t("Post")}
              </>
            )}
          </button>}

          <button type={"submit"} className={"btn btn-light"} onClick={handleSaveClick}>
            {saveClicked ? (
              <>
                <i className="fa-solid fa-spinner fa-spin-pulse me-2"></i> {t("Saving")}
              </>
            ) : (
              <>
                <i className="fa-solid fa-floppy-disk me-2"></i>
                {t("Save")}
              </>
            )}
          </button>
          {children}
          <div className="flex-grow-1 "></div>

        {!showOnPost&& <button type={"button"} className={"btn btn-light me-2"} onClick={handleCancelClick}>
            {cancelClicked ? (
              <>
                <i className="fa-solid fa-spinner fa-spin-pulse me-2"></i>
                Canceling
              </>
            ) : (
              <>
                <i className="fa-solid fa-ban me-2"></i>
                Cancel
              </>
            )}
          </button>}

          <div className="dropdown">
            <button className="btn btn-light dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false" onClick={handlePopupToggle}>
              <span className="bi bi-three-dots-vertical me-2"></span>
              {/* Transactions.. */}
            </button>

            {showPopup && (
              <ul className="dropdown-menu show">
                <li>
                  <button
                    className="dropdown-item"
                    type="button"
                    onClick={() => {
                      setShowPopup(false);
                      setIsUploadModalOpen(true);
                    }}
                  >
                    <i className="fa-solid fa-file-import me-2"></i>
                    {t("Import")}
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => {
                      setIsExportOpen(true);
                    }}
                    className="dropdown-item"
                    type="button"
                  >
                    <i className="fa-solid fa-file-export me-2"></i>
                    {t("Export")}
                  </button>
                </li>
              </ul>
            )}
          </div>
        </>
        {/*)}*/}

        {/* <button
          type={"button"}
          className={"btn btn-light me-2"}
          onClick={onClose}
        >
          <i className="bi bi-x-circle me-2"></i>
          Close
        </button> */}
      </div>

      {isExportOpen && (
        <div className="modal" style={{ display: "block" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body">
                <label htmlFor="fileName" className="me-2">
                  File Name:
                </label>
                <input id="file-name-input" type="text" value={fileName} onChange={(event) => setFileName(event.target.value)} />
              </div>

              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setIsExportOpen(false)}>
                  Cancel
                </button>

                <button
                  className="btn btn-primary"
                  onClick={() => {
                    exportToExcel();
                    setIsExportOpen(false);
                  }}
                >
                  Download
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {isUploadModalOpen && (
        <div className="modal" style={{ display: "block" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Upload from Excel</h5>
                <button type="button" className="btn-close" onClick={() => setIsUploadModalOpen(false)}></button>
              </div>
              <div className="modal-body">
                <p>Select Excel file to upload:</p>
                <input
                  type="file"
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    const selectedFile = event.target.files?.[0];
                    if (selectedFile) {
                      setFile(selectedFile);
                    }
                  }}
                />
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setIsUploadModalOpen(false)}>
                  Cancel
                </button>
                <button
                  onClick={() => {
                    setIsUploadModalOpen(false);
                    if (file) {
                      handleUploadFile(file);
                    }
                  }}
                  type="button"
                  className="btn btn-primary"
                >
                  Upload
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
